import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../service/translation.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false // Set to false to update when language changes
})
export class TranslatePipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform(value: string | undefined | null): string {
    if (!value) return '';
    return this.translationService.translate(value);
  }
}
